/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import { TransferType } from '@bb/users';

import { Icon } from 'components';

import FormContext from '../../FormContext';
import { AlertRightItems, LinkButton, StyledAlert } from '../../components';

interface IncomingPendingTransferAlertProps {
  cancelTransfer: () => Promise<void>;
}
const IncomingPendingTransferAlert = ({
  cancelTransfer,
}: IncomingPendingTransferAlertProps) => {
  const { transfer, working } = useContext(FormContext);

  if (transfer?.type !== TransferType.Incoming) return null;

  return (
    <StyledAlert
      message={
        <span>
          Your transfer request for{' '}
          <strong>
            {transfer?.user.firstName} {transfer?.user.lastName}
          </strong>{' '}
          to be transferred from{' '}
          <strong>{transfer?.otherOrgDetails.name}</strong> is pending
        </span>
      }
      action={
        <AlertRightItems>
          <LinkButton onClick={cancelTransfer} disabled={working}>
            Cancel
          </LinkButton>
        </AlertRightItems>
      }
      type="warning"
      showIcon
      icon={<Icon type="antdSwapOutlined" color="alertWarningIconColor" />}
    />
  );
};

export default IncomingPendingTransferAlert;
